import {
  addDays as addDaysFns,
  addWeeks,
  getTime,
  format,
  formatRFC3339,
  isEqual,
  isSameDay as isSameDayFns,
  isWeekend,
  startOfWeek
} from 'date-fns';
import { es } from 'date-fns/locale';
import { getLocale, translate } from 'translations/translator';

const getTranslation = key => translate('common', key);

export const uiDateFormat = getTranslation('uiDateFormat');

export const formatUiDate = (date: Date): string => format(date, uiDateFormat);
export const formatFullDate = (date: Date): string => formatRFC3339(date, { fractionDigits: 3 });

export const addDays = (date: Date, days: number): Date => {
  const newDate = addDaysFns(date, days);
  return isWeekend(newDate) ? addDays(newDate, 1) : newDate;
};

export const getEpochTime = (dateStr: string): number => getTime(new Date(dateStr));

export const isEqualDate = (dateStr1: string | Date, dateStr2: string | Date): boolean =>
  isEqual(new Date(dateStr1), new Date(dateStr2));

export const isSameDay = (dateStr1: string, dateStr2: string): boolean =>
  isSameDayFns(new Date(dateStr1), new Date(dateStr2));

export const getDayOfWeek = (date: Date): string => {
  return format(date, 'EEEE', { ...(getLocale() === 'es-US' && { locale: es }) });
};

export const getStartOfWeek = (date: Date = new Date()): Date => {
  if (!isWeekend(date)) return startOfWeek(date, { weekStartsOn: 1 });
  return addWeeks(startOfWeek(date, { weekStartsOn: 1 }), 1);
};

export const getWeekday = (date: Date = new Date()): Date => {
  if (!isWeekend(date)) return date;
  return addWeeks(startOfWeek(date, { weekStartsOn: 1 }), 1);
};
